// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>43</span>&nbsp;&nbsp;Whoever is wise will ponder these things&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and consider the loving-kindness of the Lord.<br> </p> </div></div>";
// Exports
module.exports = code;